import { lazy } from "react";

const routes = [
  {
    path: "/create_combo",
    element: lazy(() =>
      import("../pages/ComboProduct/CreateCombo/CreateCombo")
    ),
  },
  {
    path: "/edit_combo_pricing",
    element: lazy(() =>
      import("../pages/ComboProduct/OnlineComboDetails/EditComboPricing")
    ),
  },
  {
    path: "/online_promotion_products",
    element: lazy(() =>
      import("../pages/ComboProduct/OnlineComboDetails/OnlinePromotionProducts")
    ),
  },

  {
    path: "/promotion_products",
    element: lazy(() =>
      import("../pages/ComboProduct/CreateCombo/PromotionProducts")
    ),
  },
  {
    path: "/add_pricing",
    element: lazy(() => import("../pages/ComboProduct/CreateCombo/AddPricing")),
  },
  {
    path: "/edit_combo",
    element: lazy(() => import("../pages/ComboProduct/EditCombo/EditCombo")),
  },
];

export default routes;
